import translator from '@Components/Utilities/Translator';
import { useRef, useEffect } from 'react';

const FacetedSearchSelectedFacet = (props) => {
    const queryStringRegex = new RegExp('(\\?|&)' + props.FieldName + '=', 'gi');
    const clickedClearRef = useRef(false);

    const clearFacet = (fieldName, option) => {
        if (clickedClearRef.current || props.disabled) return;
        clickedClearRef.current = true;
        if (!props.IsSpecGroup) {
            if (option && option.IsSpecLandingTerm && props.SpecLandingTermGroup) {
                props.ClearFacet(props.SpecLandingTermGroup, option);
            }
            else {
                props.ClearFacet(fieldName, option);
            }               
        } else {
            props.ClearFacet(option.Value.replace(' ', ''), '1');
        }
    };

    useEffect(() => {
        if (!props.disabled) {
            clickedClearRef.current = false;
        }
    }, [props.ClearFacet, props.disabled]);

    const getCheckedOptions = () => {
        return props.Options.filter((op) => op.Checked);
    };

    const getCheckedOptionDisplayName = (option) => {
        if (option.SelectedOptionDisplayText) {
            return option.SelectedOptionDisplayText;
        }
        if (option.ParentName && option.ParentValue && !option.IsGroup) {
            let parentOptions = props.Options.filter((op) => op.Value == option.ParentValue);
            if (parentOptions && parentOptions.length > 0) {
                let parentOption = parentOptions[0];
                if (parentOption && parentOption.IsFilterByOption) {
                    return option.Name + ' ' + option.ParentName;
                }
            }
        }
        return option.Name;
    };

    const selectedFacetMarkup = (option) => {
        let AccessibilityContainer;
        let clearFacetOnClick;
        let key;
        let facetDisplayName;

        if (props.IsNoListingsFoundSection) {
            AccessibilityContainer = 'div';
        } else {
            AccessibilityContainer = 'button';
        }

        if (option) {
            clearFacetOnClick = () => clearFacet(props.FieldName, option);
            facetDisplayName = getCheckedOptionDisplayName(option);
            key = option.ReactKey;
        } else {
            clearFacetOnClick = () => clearFacet(props.FieldName, props.Value ?? null);
            facetDisplayName = props.SelectedFacetText ? props.SelectedFacetText : props.DisplayName;
            key = props.FieldName;
        }
        return (
            <AccessibilityContainer key={key} className='selected-facet ts-button' onClick={() => clearFacetOnClick()} disabled={props.disabled}>
                {!props.IsNoListingsFoundSection ?
                    <>
                        <i className='fas fa-times' />
                        {facetDisplayName}
                    </>
                    :
                    <>
                        <b>{facetDisplayName}</b>
                        <button className='ts-button template-branded-button' onClick={() => clearFacetOnClick()} aria-label={translator.translate('sandhills.remove') + ' ' + facetDisplayName}>({translator.translate('sandhills.remove')})</button>
                    </>
                }
            </AccessibilityContainer>
        );
    };

    switch (props.Type) {
        case 'Checkbox':
            return (getCheckedOptions().map(option =>
                selectedFacetMarkup(option)
            ));
        case 'DateRange':
            if (props.InputIsSelected) {
                return (
                    selectedFacetMarkup()
                );
            }
            break;
        case 'Hidden':
            return (
                selectedFacetMarkup()
            );
            break;
        case 'Range':
        case 'RangeCombo':
            if (queryStringRegex.test(props.SearchURL)) {
                return (
                    selectedFacetMarkup()
                );
            }
            break;
        case 'Text':
            if (queryStringRegex.test(props.SearchURL)) {
                return (
                    selectedFacetMarkup()
                );
            }
            break;
        case 'Distance':
            if (queryStringRegex.test(props.SearchURL)) {
                return (
                    selectedFacetMarkup()
                );
            }
            break;
    }

    return (<></>);
};

export default FacetedSearchSelectedFacet;